
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[categoryUrl]",
      function () {
        return require("private-next-pages/category/[categoryUrl].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[categoryUrl]"])
      });
    }
  